import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { customerBillingList } from "../actions/shipmentNPayment";
import Table from "../common/Table";
import { NavWrap, TableWrap } from "./ShopForTyres";

import moment from "moment";

const Payments = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const billing_list = useSelector(
    (state) => state?.shipNPay?.customer_billing_list
  );

  useEffect(() => {
    let obj = {
      email: localStorage.getItem("email"),
    };
    dispatch(customerBillingList(obj));
    // eslint-disable-next-line
  }, []);
  const columns = [
    {
      header: "Order ID",
      accessor: "OrderId",
      width: 12,
    },
    {
      header: "Invoice No",
      accessor: "InvoiceNo",
      width: 12,
    },
    {
      header: "Invoice Date",
      accessor: "invoice_date",
      width: 12,
    },
    {
      header: "Due Date",
      accessor: "date",
      width: 12,
    },
    {
      header: "PO Number",
      accessor: "po_number",
      width: 10,
      cell: (row) => <span className="error-text">{row.po_number}</span>,
    },
    {
      header: "Quantity",
      accessor: "quantity",
      width: 10,
    },
    {
      header: "Total Amount",
      accessor: "amount",
      width: 10,
    },
    {
      header: "PI Status",
      accessor: "PiStatus",
      width: 12,
      cell: (row) => <span className="text-btn">{row.PiStatus}</span>,
      className: "pi_status",
    },
    {
      header: "Payment Status",
      accessor: "OrderStatus",
      width: 12,
      cell: (row) => <span className="success-text">{row.OrderStatus}</span>,
    },
  ];

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={"Payments"}
          showGrid={false}
          searchPlaceholder={"Search by order id..."}
          namedFilters={[
            "All (27)",
            "Pending (12)",
            "Completed (14)",
            "Canceled (1)",
          ]}
          isDateFilter={true}
          options={[{ label: "All Dates", value: "all" }]}
          label={""}
        >
          <Table
            columns={columns}
            data={billing_list?.data}
            action={false}
            actionWidth={8}
            onRowClick={(row) => {
              history.push("/admin/payment-doc", {
                order_no: row?.OrderId,
                time: moment(row?.SoDate, "YYYYMMDD").format("DD MMM, YYYY"),
                billNo: row?.InvoiceNo,
              });
            }}
          />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default Payments;
